module.exports = __webpack_public_path__ + "img/收储贷（对公）.f4270dae.png";